var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cobalt, teal } from '../colors';
/* eslint-disable react/jsx-curly-brace-presence */
export class Deselected extends PureComponent {
    render() {
        const _a = this.props, { width, color, backgroundColor } = _a, rest = __rest(_a, ["width", "color", "backgroundColor"]);
        return (React.createElement("svg", Object.assign({ width: width, height: width, viewBox: "0 0 24 24" }, rest),
            React.createElement("defs", null,
                React.createElement("path", { id: "radio-default-a", d: `M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,
            2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,
            21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z` })),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("circle", { cx: "12", cy: "12", r: "12", stroke: "black", strokeWidth: "0", fill: backgroundColor }),
                React.createElement("use", { fill: color, xlinkHref: "#radio-default-a" }))));
    }
}
Deselected.propTypes = {
    width: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
};
Deselected.defaultProps = {
    width: '16px',
    color: cobalt.base,
    backgroundColor: 'none',
};
export class Selected extends PureComponent {
    render() {
        const _a = this.props, { width, color, backgroundColor } = _a, rest = __rest(_a, ["width", "color", "backgroundColor"]);
        return (React.createElement("svg", Object.assign({ width: width, height: width, viewBox: "0 0 24 24" }, rest),
            React.createElement("defs", null,
                React.createElement("path", { id: "selected-a", d: `M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,
            12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,
            12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,
            17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,
            6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z` })),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("circle", { cx: "12", cy: "12", r: "12", stroke: "black", strokeWidth: "0", fill: backgroundColor }),
                React.createElement("use", { fill: color, xlinkHref: "#selected-a" }))));
    }
}
Selected.propTypes = {
    width: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
};
Selected.defaultProps = {
    width: '16px',
    color: teal.base,
    backgroundColor: 'none',
};
